<template>
  <div class="container addCapacity">
    <div class="searchBox_top">
      <el-button type="primary" @click="saveDetail()">{{$t('common.saveDraft')}}</el-button>
      <!--保存-->
      <el-button type="primary" @click="submitDetail()">{{$t('common.release')}}</el-button>
      <!--提交-->
      <el-button type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
    </div>
    <el-form :model="capacityDetail" ref="capacityDetail" label-width="150px" :rules="capacityDetailRules">
      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('supplierManage.Category1')" prop="category1">
            <el-select v-model="capacityDetail.category1" clearable @change="changeCategory1()">
              <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('supplierManage.Category2')" prop="category2">
            <el-select v-model="capacityDetail.category2" clearable>
              <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col v-show="growthRateY1Show" :span="4">
          <el-form-item :label="growthRateY1Title" prop="growthRateY1" class="growthRateYTitle">
            <el-input v-model="capacityDetail.growthRateY1" clearable maxLength='10' oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>%
          </el-form-item>
        </el-col>
        <el-col :offset="1" v-show="growthRateY2Show" :span="4">
          <el-form-item :label="growthRateY2Title" prop="growthRateY2" class="growthRateYTitle">
            <el-input v-model="capacityDetail.growthRateY2" clearable maxLength='10' oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>%
          </el-form-item>
        </el-col>
        <el-col :offset="1" v-show="growthRateY3Show" :span="4">
          <el-form-item :label="growthRateY3Title" prop="growthRateY3" class="growthRateYTitle">
            <el-input v-model="capacityDetail.growthRateY3" clearable maxLength='10' oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>%
          </el-form-item>
        </el-col>

        <el-col :offset="1" :span="4" v-show="growthRateY4Show">
          <el-form-item :label="growthRateY4Title" prop="growthRateY4" class="growthRateYTitle">
            <el-input v-model="capacityDetail.growthRateY4" clearable maxLength='10' oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>%
          </el-form-item>
        </el-col>
        <el-col :offset="1" :span="4" v-show="growthRateY5Show">
          <el-form-item :label="growthRateY5Title" prop="growthRateY5" class="growthRateYTitle">
            <el-input v-model="capacityDetail.growthRateY5" clearable maxLength='10' oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>%
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>

      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item :label="$t('common.remarks')" prop="remarks">
            <!--备注-->
            <el-input type="textarea" maxlength="300" autosize class="handle-input" v-model="capacityDetail.remarks"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item :label="$t('capacity.UploadCapacityDetails')">
            <el-table :data="detailDocfileList" border highlight-current-row class="detailDocfileList">
              <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
                <template slot-scope="scope">
                  <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="tmDocumentId" min-width="130px">
                <template slot-scope="scope">
                  <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,detailDocfileList)">{{$t('common.del')}}</el-link>
                </template>
              </el-table-column>
            </el-table>
            <el-upload ref="uploadRef" action="upload" :http-request="uploadConfirm" :on-remove="detailDocfileRemove" multiple show-file-list="false" name="file">
              <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
              <!--选取文件-->
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button type="primary" @click="addSupplier">{{$t('base.supplier.addSupplier')}}</el-button>
    <!--添加-->
    <el-button type="danger" @click="delSupplier()">{{$t('common.del')}}</el-button>
    <el-form :model="supplierCapacityForm" ref="supplierCapacityForm" :rules="supplierCapacityFules">
      <el-table :data="supplierCapacityForm.supplierCapacityList" ref="supplierCapacityList" border highlight-current-row max-height='420'>
        <el-table-column show-overflow-tooltip prop="tmSupplierId" type="selection" min-width="55" />
        <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('spm.invitationCode')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('capacity.supplierNameShort')"></el-table-column>
      </el-table>
    </el-form>
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier ref="supplierSelRef" :multipleSelectionFlag="true" v-if="SupplierNameDialogReset" @subCallMethod="selectSupplierMethod"></SelSupplier>
    </el-dialog>
  </div>

</template>

<script>
import capacityApi from "@/api/capacity/capacity";
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import { apiService } from "@/api/material/material-master-data";
import SelSupplier from '@/components/page/BCManage/supplierGroup';
import { Message } from "element-ui";
export default {
  components: { IcSelect, SelSupplier },
  computed: {
    capacityDetailRules() {
      let that = this;
      return {
        category1: [{ required: true, message: that.$t("visitPlan.noEmpty"), trigger: "change" }],
        category2: [{ required: true, message: that.$t("visitPlan.noEmpty"), trigger: "change" }],
        /*growthRate: [ { required: true,message: this.$t("visitPlan.noEmpty"), trigger: "blur"}],*/
        growthRateY1: that.growthRateY1Show ? [{ required: true, message: that.$t("visitPlan.noEmpty"), trigger: "blur" }] : [],
        growthRateY2: that.growthRateY2Show ? [{ required: true, message: that.$t("visitPlan.noEmpty"), trigger: "blur" }] : [],
        growthRateY3: that.growthRateY3Show ? [{ required: true, message: that.$t("visitPlan.noEmpty"), trigger: "blur" }] : [],
        growthRateY4: that.growthRateY4Show ? [{ required: true, message: that.$t("visitPlan.noEmpty"), trigger: "blur" }] : [],
        growthRateY5: that.growthRateY5Show ? [{ required: true, message: that.$t("visitPlan.noEmpty"), trigger: "blur" }] : []
      }
    },
  },
  data() {

    return {
      showSelSupplierDialog: false,
      SupplierNameDialogReset: false,
      capacityDetail: {
        category1: '', category2: '',
        growthRate: '',
      },
      supplierCapacityForm: {
        supplierCapacityList: [],
      },
      categoryList1: [],
      categoryList2: [],
      status: '',
      growthRateY1Show: false,
      growthRateY2Show: false,
      growthRateY3Show: false,
      growthRateY4Show: false,
      growthRateY5Show: false,
      growthRateY1Title: this.$t("capacity.growthRate"),
      growthRateY2Title: this.$t("capacity.growthRate"),
      growthRateY3Title: this.$t("capacity.growthRate"),
      growthRateY4Title: this.$t("capacity.growthRate"),
      growthRateY5Title: this.$t("capacity.growthRate"),
      submitFlag: false,
      severalYears: 0,
      detailDocfileList: [],//请详细描述发生问题 的附件
      detailDocfileList2: [],
    }
  },
  created() {
    this.ttCapacityId = this.$route.query.ttCapacityId;
    //得到模板信息
    let caId = -999;
    if (this.ttCapacityId) { caId = this.ttCapacityId; }
    capacityApi.getTemplateByCapacity(caId).then(res => {
      if (res.code == '200') {
        let beginYear = res.data.beginYear;
        this.severalYears = res.data.severalYears;
        let add = this.$t("capacity.growthRate");
        for (let inx = 0; inx < res.data.severalYears; inx++) {
          switch (inx) {
            case 0: this.growthRateY1Title = (beginYear + inx) + 'vs' + (beginYear + inx - 1) + add; this.growthRateY1Show = true; break;
            case 1: this.growthRateY2Title = (beginYear + inx) + 'vs' + (beginYear + inx - 1) + add; this.growthRateY2Show = true; break;
            case 2: this.growthRateY3Title = (beginYear + inx) + 'vs' + (beginYear + inx - 1) + add; this.growthRateY3Show = true; break;
            case 3: this.growthRateY4Title = (beginYear + inx) + 'vs' + (beginYear + inx - 1) + add; this.growthRateY4Show = true; break;
            case 4: this.growthRateY5Title = (beginYear + inx) + 'vs' + (beginYear + inx - 1) + add; this.growthRateY5Show = true; break;
          }
        }
      }
    });
    if (this.$route.query.ttCapacityId) {
      this.getDetail(this.$route.query.ttCapacityId)
    }
    this.getCategoryList()
  },
  methods: {
    getDetail(ttCapacityId) {
      capacityApi.newCapacityInfo(ttCapacityId).then(res => {
        this.capacityDetail = res.data.capacity
        this.status = res.data.capacity.status
        this.supplierCapacityForm.supplierCapacityList = res.data.supplierCapacityList
        if (!!res.data.caDetailDoc) {
          this.detailDocfileList = res.data.caDetailDoc;
        }
        apiService.findCategory({ categoryLevel: 2, pid: this.capacityDetail.category1 }).then((res) => {
          this.categoryList2 = res.data;
        });
      });
    },
    saveDetail() {
      let that = this
      let data = {
        capacity: this.capacityDetail,
        submit: false,
        supplierCapacityList: that.supplierCapacityForm.supplierCapacityList,
        caDetailDoc: that.detailDocfileList.concat(that.detailDocfileList2)
      }
      capacityApi.saveCapacity(data).then(res => {
        if (res.code == '200') {
          //清空附件
          if (this.$refs.uploadRef != undefined) {
            that.$refs.uploadRef.clearFiles();
          }
          that.detailDocfileList2 = [];
          that.$message({
            message: this.$t("common.saveSuccess"),
            type: "success"
          });
          that.getDetail(res.data)
        }
      });
    },
    submitDetail() {
      let that = this;
      this.submitFlag = true;
      this.$refs.capacityDetail.validate(valid => {
        debugger
        if (valid) {
          let data = {
            capacity: this.capacityDetail,
            submit: true,
            supplierCapacityList: that.supplierCapacityForm.supplierCapacityList,
            caDetailDoc: that.detailDocfileList.concat(that.detailDocfileList2)
          }
          if (that.supplierCapacityForm.supplierCapacityList.length == 0) {
            that.$message({ message: that.$t("supplierManage.PleaseAddSupplier"), type: "warning" });
            return
          }

          capacityApi.saveCapacity(data).then(res => {
            if (res.code == '200') {
              that.$router.go(-1);
              that.$message({
                message: this.$t("common.submitSuccess"),
                type: "success"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //添加供应商
    addSupplier() {
      this.showSelSupplierDialog = true;
      this.$nextTick(() => {
        this.SupplierNameDialogReset = true;
      });
    },
    selectSupplierMethod: function (supList) {
      let that = this;
      that.SupplierNameDialogReset = false;
      if (supList.length == 0) {
        that.showSelSupplierDialog = false;
        return;
      }
      let supplierCapacityList = that.supplierCapacityForm.supplierCapacityList
      supplierCapacityList.forEach(function (item, index) {
        supList.forEach(function (itemI, indexI) {
          // 如果选中数据跟 已经选的相等，删除对应的源数据
          if (item.tmSupplierId === itemI.tmSupplierId) {
            supList.splice(indexI, 1);
          }
        });
      });
      let temp = supList.map(function (item, index) {
        let obj = {
          tmSupplierId: item["tmSupplierId"],
          supplierCode: item["supplierCode"],
          supplierName: item["supplierName"],
          contactPerson: item["linkman"],
          email: item["emailAddress"],
          supplierStatusI18n: item["supplierStatusI18n"],
        }
        return obj;
      });
      if (temp.length > 0) {
        that.supplierCapacityForm.supplierCapacityList.push.apply(that.supplierCapacityForm.supplierCapacityList, temp)
      }
      that.showSelSupplierDialog = false;
    },
    //删除地址
    delSupplier() {
      let that = this
      let list = this.supplierCapacityForm.supplierCapacityList;
      let rows = this.$refs.supplierCapacityList.selection;
      if (rows.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return
      } else {
        rows.forEach(function (item, index) {
          list.forEach(function (itemI, indexI) {
            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
            if (item.tmSupplierId === itemI.tmSupplierId) {
              list.splice(indexI, 1);
            }
          });
        });
      }
      this.supplierCapacityForm.supplierCapacityList = list;
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.capacityDetail.category2 = null
      this.categoryList2 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.capacityDetail.category1 }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    //详情描述上传文件
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        _this.detailDocfileList2.push(res.data[0])
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //详情描述文件删除
    detailDocfileRemove(file) {
      for (let j = 0; j < this.detailDocfileList2.length; j++) {
        if (this.detailDocfileList2[j].documentName == file.name) {
          this.detailDocfileList2.splice(j, 1)
        }
      }
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },

  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 20px;
}
.el-table {
  margin-top: 10px;
}
.el-select {
  width: 100%;
}
.el-date-editor {
  width: 100%;
}
</style>
<style lang="scss">
.addCapacity {
  .el-table.detailDocfileList {
    thead {
      display: none !important;
    }
  }
  .growthRateYTitle {
    .el-form-item__content {
      display: flex;
    }
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
  }
}
</style>
